export const SERVICE_COLORS = {
  'auth-service':          '#0ea5e9', // sky
  'libraries-service':     '#f97316', // orange
  'talent-service':        '#ef4444', // red
  'account-service':       '#3b82f6', // blue
  'jobs-service':          '#3b82f6', // blue
  'attendance-service':    '#a855f7', // purple
  'task-manager-service':  '#14b8a6', // teal
  'media-library-service': '#10b981', // emerald
  'courses-service':       '#06b6d4', // cyan
  'crm-service':           '#ec4899', // pink
};

export const WILDCARD_COLOR = '#f59e0b';
export const DEFAULT_SERVICE_COLOR = '#6b7280';

export function getServiceColor(service) {
  return SERVICE_COLORS[service] || DEFAULT_SERVICE_COLOR;
}

export function extractServiceFromPermission(permission) {
  if (permission?.permission?.service) return permission.permission.service;
  if (permission?.service) return permission.service;
  if (typeof permission?.name === 'string') return permission.name.split('.')[0];
  return null;
}

export function getPermissionColor(permission) {
  const isWildcard =
    permission?.permission?.isWildcard ||
    permission?.isWildcard ||
    false;
  if (isWildcard) return WILDCARD_COLOR;
  return getServiceColor(extractServiceFromPermission(permission));
}

export function getPermissionChipSx(permission, { isActive = true } = {}) {
  const hex = getPermissionColor(permission);
  if (!isActive) {
    return {
      bgcolor: 'transparent',
      color: hex,
      border: `1px solid ${hex}`,
    };
  }
  return {
    bgcolor: hex,
    color: '#fff',
    '& .MuiChip-deleteIcon': {
      color: 'rgba(255,255,255,0.7)',
      '&:hover': { color: '#fff' },
    },
  };
}
